import {Injectable} from '@angular/core';
import {OAuthEvent, OAuthService} from 'angular-oauth2-oidc';
import {HttpHeaders, HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {HttpErrorHandlerService, HandleError} from './http-error-handling.service';
import {catchError} from 'rxjs/operators';
import {firstValueFrom, throwError} from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class VxCoreService {
  private handleError: HandleError;

  constructor(private oauthService: OAuthService,
              private http: HttpClient) {

    this.oauthService.events.subscribe((event: OAuthEvent) => {
      const tokenUpdatedEvents = ['token_refreshed', 'token_received', 'silently_refreshed'];
      if (tokenUpdatedEvents.includes(event.type)) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
      }
    });

    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
  }

  /**
   * Checks the eligibility of a VX Application
   * @param appId
   */
  checkVxApplicationEligibility(appId: number) {
    return this.http.get<any[]>(`${environment.api.vxCore}/applications/${appId}/further-advance-eligibility`, httpOptions)
      .pipe(
        catchError(error => {
          console.error('There was an error!', error);
          return throwError(error);
        })
      );
  }

  public checkTontoImported(tontoId) {
    return firstValueFrom(this.http.get(`${environment.api.vxCore}/applications/tonto/${tontoId}`, httpOptions));
  }

  public estimatedLvr(appId: number, data: any) {
    return this.http.post<any[]>(`${environment.api.vxCore}/applications/${appId}/lvr`, data, httpOptions);
  }
}
